"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectingAttributeItem = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
exports.ConnectingAttributeItem = function (_a) {
    var title = _a.title, icon = _a.icon, selected = _a.selected, onClick = _a.onClick;
    var handleOnClick = function (e) {
        onClick();
        e.preventDefault();
    };
    var className = classnames_1.default("gd-list-item", "s-" + util_1.stringUtils.simplifyText(title), {
        "is-selected": selected,
    });
    return (react_1.default.createElement("div", { className: className, onClick: handleOnClick },
        react_1.default.createElement("span", { className: classnames_1.default("gd-list-icon", icon) }),
        react_1.default.createElement("span", null, title)));
};
//# sourceMappingURL=ConnectingAttributeItem.js.map